// export const SERVER_ADDRESS = `http://localhost:5001/dashboard`
export const SERVER_ADDRESS = `https://skyramatrimony.com/backend/dashboard`
// export const SERVER_ADDRESS = `https://matrimony.skyraantech.com/backend/dashboard`